import { useMutation, useQueryClient } from 'react-query';
import { AxiosError, AxiosResponse } from 'axios';
import cookies from 'js-cookie';
import request from 'src/utils/request';

/// //////////////////////////////////////////////////
/// /////////////////   APIs   ///////////////////////
/// //////////////////////////////////////////////////

const login = async (userData: any) => {
	const { data } = await request.post('/account/auth', userData);
	return data;
};

/// //////////////////////////////////////////////////
/// /////////////////  Hooks  ////////////////////////
/// //////////////////////////////////////////////////

const useLogin: any = () => {
	const queryClient = useQueryClient();

	return useMutation<AxiosResponse, AxiosError, any, () => void>(login, {
		onSuccess: (resData) => {
			request.setToken(resData.data.token);
			cookies.set('jwt', resData.data.token, { expires: 100 });
			queryClient.setQueryData('user', resData.data);
		},
	});
};

const useLogout: any = () => {
	const queryClient = useQueryClient();

	const logout = () => {
		cookies.remove('jwt');
		request.removeToken();
		queryClient.setQueryData('user', null);
		window.replace('/login');
	};

	return { logout };
};

export { useLogin, useLogout };
